export const GLADSTONE_UNAUTHORIZED_MESSAGE = 'Not authorized to perform this operation!';
